/* eslint-disable react/jsx-handler-names */
import { find, get, isEmpty, reduce, size } from "lodash";
import { MDBAlert, MDBInput, MDBSpinner } from "mdbreact";
import React, { Component, Fragment } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  resetAlertSubmitFail,
  submitPayment
} from "~/actions/umc/submitPayment";
import Alert from "~/components/common/atoms/Alert";
import Modal from "~/components/common/molecules/Modal";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { openToast } from "~/components/common/molecules/ToastNotification";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import {
  getAllPaymentMethod,
  getAllPaymentMultiBooking,
  hideModalPaymentMethod,
  resetPaymentMethod,
  selectedPaymentMethod,
  togglePaymentMethod
} from "~/store/payment/paymentAction";
import {
  getBookingTree,
  reserveBooking,
  reserveBookingRePayment,
  reserveMultipleBookings
} from "~/store/totalData/actions";
import { getRouteFollowPartnerId } from "~/utils/func";
import styles from "./style.module.scss";
import { isMobile } from "react-device-detect";
import { createForm, createFormField } from "rc-form";
import cx from "classnames";
import isEmail from "validator/lib/isEmail";
import isHTML from "is-html";
import { client } from "~/utils/medproSDK";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentMethodPageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/PaymentMethod"),
  loading: LoadableLoading
});

class DetectPaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowAlert: false,
      isShowPaymentConfirm: false,
      loadingSubmitBooking: false,
      updateVisa: {
        status: false,
        initValue: {}
      },
      isCheckedVisa: false,
      visaEntered: {
        status: false,
        info: {
          fullName: "",
          userName: "",
          email: ""
        }
      },
      referralCode: "",
      isShowBlvpModal: false,
      blvpContent: null
    };
  }
  styles = {
    loading: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },

    loading_submit_booking: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: "black",
      opacity: 0.5
    },

    body_modal: {
      fontSize: "1rem"
    },
    body_modal_image: {
      margin: "auto",
      display: "block",
      objectFit: "cover",
      marginBottom: "10px",
      maxHeight: "100px"
    }
  };

  methods = {
    calculate: () => {
      const { schedulesSelected, selectedMethod } = this.props;
      // summary để dùng tính tổng tiền cho nhiều chuyên khoa (umc)
      const total = reduce(
        schedulesSelected,
        (sum, item) => {
          const price = Number(item.service.price);
          return sum + price;
        },
        0
      );
      const medpro = selectedMethod.medproFee
        ? Number(selectedMethod.medproFee)
        : 0;
      const fee = selectedMethod.rate ? Number(selectedMethod.rate) : 0;
      const feeMore = selectedMethod.constRate
        ? Number(selectedMethod.constRate)
        : 0;
      const phi = parseInt((total + medpro) * fee + feeMore);
      const phiThanhToan = phi;
      const phiThanhToanGiaoDich = phiThanhToan || 0;
      const totalPhi = medpro + phiThanhToanGiaoDich;
      return {
        total,
        totalPhi
      };
    },
    toggleAlertFail: () => {
      this.props.OnResetErrorMessgeSubmitPayment();
      this.setState(state => ({
        loadingSubmitBooking: false
      }));
    },
    handleDoPayment: (referralCode = "") => {
      // Sử dụng referralCode từ parameter hoặc từ state
      const finalReferralCode = referralCode || this.state.referralCode;
      const { isRepayment, selectedMethod, schedulesSelected } = this.props;
      const { visaEntered } = this.state;
      const params = {
        fullname: visaEntered.info.fullName,
        username: visaEntered.info.userName,
        email: visaEntered.info.email
      };
      if (Object.keys(selectedMethod).length < 1) {
        openToast("Vui lòng chọn phương thức thanh toán", "error");
      } else {
        if (isRepayment) {
          this.props.repaymentBooking(params);
        } else {
          if (schedulesSelected.length > 1) {
            this.props.reserveMultipleBookings(finalReferralCode);
          } else {
            this.props.reserveBooking(finalReferralCode);
          }
        }
        this.setState(state => ({
          isShowPaymentConfirm: false
        }));
      }
    },

    setReferralCode: referralCode => {
      this.setState({ referralCode });
    },

    toggleShowPaymentConfirm: () => {
      this.setState(state => ({
        isShowPaymentConfirm: !state.isShowPaymentConfirm
      }));
    },

    handleSelectedMethod: (method, methodId, paidService) => {
      if (method.checkEmail && !this.state.visaEntered.status) {
        this.methods.toogleModalVisa();
        return;
      }
      this.props.selectedPaymentMethod(method, methodId, paidService);
    },
    toggleAlert: () => {
      this.setState({
        isShowAlert: !this.state.isShowAlert
      });
    },
    handleGoBack: () => {
      const { partnerId } = this.props;
      const route = getRouteFollowPartnerId("/xac-nhan-thong-tin", partnerId);
      this.props.history.push(route);
    },
    handleUpdateInfoUser: () => {
      this.props.form.validateFields((error, value) => {
        const { fullName, userName, email } = value;
        if (!error) {
          openToast("Cập nhật thông tin thành công");
          this.methods.toogleModalVisa();
          this.setState({
            visaEntered: {
              status: true,
              info: {
                fullName,
                userName,
                email
              }
            }
          });
        }
      });
    },
    toogleModalVisa: () => {
      const { updateVisa, visaEntered } = this.state;
      if (!visaEntered.status) {
        this.setState(preState => ({
          updateVisa: { ...preState, status: !updateVisa.status }
        }));
      }
    },
    renderBodyModalConfirmPayment: props => {
      const { selectedMethod } = this.props;
      const selectedMethodName =
        Object.keys(selectedMethod).length > 0
          ? selectedMethod.name
          : "Chọn phương thức thanh toán";

      // const price = get(selectedMethod, "grandTotal", 0);
      const grandTotalTemp = get(selectedMethod, "grandTotal", 0);
      const partialGrandTotal = get(selectedMethod, "partialGrandTotal", 0);
      const grandTotal = props.paidService ? grandTotalTemp : partialGrandTotal;
      const selectedMethodImage = get(selectedMethod, "paymentIcon.path", "");

      if (selectedMethod.bankAccount) {
        const accountHolder = get(
          selectedMethod,
          "bankAccount.accountHolder",
          ""
        );
        const accountNumber = get(
          selectedMethod,
          "bankAccount.accountNumber",
          ""
        );
        const bankBranch = get(selectedMethod, "bankAccount.bankBranch", "");
        return (
          <Fragment>
            <div style={this.styles.body_modal}>
              {selectedMethodImage && (
                <img
                  style={this.styles.body_modal_image}
                  src={selectedMethodImage}
                  alt={selectedMethodName}
                />
              )}
              <MDBAlert color="primary">
                <p>Thông tin chuyển khoản:</p>
                Tài khoản: <strong>{accountHolder}</strong> <br />
                Số tài khoản: <strong>{accountNumber}</strong> <br />
                Chi nhánh: <strong>{bankBranch}</strong> <br />
                Số tiền:{" "}
                <strong>{Number(grandTotal).toLocaleString("vi-VN")}đ</strong>
              </MDBAlert>
            </div>
          </Fragment>
        );
      }

      return (
        <Fragment>
          <div style={this.styles.body_modal}>
            {selectedMethodImage && (
              <img
                style={this.styles.body_modal_image}
                src={selectedMethodImage}
                alt={selectedMethodName}
              />
            )}
            <p>
              Thanh toán số tiền{" "}
              <strong>{Number(grandTotal).toLocaleString("vi-VN")}đ</strong>{" "}
              bằng {selectedMethodName}
            </p>
            <MDBAlert color="primary">
              Bạn sẽ nhận được phiếu khám bệnh ngay khi{" "}
              <strong>thanh toán thành công</strong>. Trường hợp không nhận được
              phiếu khám bệnh, vui lòng liên hệ <strong>19002115</strong>.
            </MDBAlert>
          </div>
        </Fragment>
      );
    },
    fetchBLVPContent: async () => {
      const { schedulesSelected } = this.props;
      console.log("first", schedulesSelected);
      const serviceId = get(schedulesSelected, "[0].service.id", "");
      try {
        const res = await client.getBLVPPopupContent({ serviceId });
        if (res && res.data) {
          this.setState({
            blvpContent: res.data,
            isShowBlvpModal: true
          });
        }
      } catch (error) {
        console.log("fetchBLVPContent error", error);
      }
    },
    toggleBlvpModal: () => {
      this.setState(state => ({
        isShowBlvpModal: !state.isShowBlvpModal
      }));
    }
  };
  renderBodyVisaUmc = () => {
    const {
      form: { getFieldProps, getFieldsError }
    } = this.props;
    const {
      fullName: fullNameError,
      userName: userNameError,
      email: emailError
    } = getFieldsError();
    return (
      <div>
        <p className={styles.description}>
          Theo quy định của Tổ chức thẻ Quốc tế, vui lòng điền đầy đủ thông tin
          người thanh toán
        </p>
        <div className={styles.form_column}>
          <form
            className={cx(styles.form_contact_info, styles.form_contact_custom)}
          >
            <div className={styles.form_group}>
              <label htmlFor="label_name">
                Họ & tên<sup>*</sup>
              </label>
              <input
                {...getFieldProps("fullName", {
                  rules: [
                    {
                      required: true,
                      message: "Vui lòng nhập họ và tên"
                    }
                  ]
                })}
                id="label_name"
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập họ và tên"
              />
              <span className={styles.input_warning}>{fullNameError}</span>
            </div>

            <div className={styles.form_group}>
              <label htmlFor="label_mobile">
                Số điện thoại<sup>*</sup>
              </label>
              <input
                {...getFieldProps("userName", {
                  rules: [
                    {
                      validator: this.validatePhone
                    }
                  ]
                })}
                id="label_mobile"
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập số điện thoại"
              />
              <span className={styles.input_warning}>{userNameError}</span>
            </div>

            <div className={styles.form_group}>
              <label htmlFor="label_email">
                Email<sup>*</sup>
              </label>
              <input
                {...getFieldProps("email", {
                  rules: [{ validator: this.validatorEmail }]
                })}
                id="label_email"
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập email"
              />
              <span className={styles.input_warning}>{emailError}</span>
            </div>

            <div className={styles.form_group}>
              <MDBInput
                {...getFieldProps("confirm")}
                label="Tôi xác nhận thông tin trên là chính xác và hoàn toàn chịu
                    trách nhiệm về thông tin này."
                type="checkbox"
                id="confirm"
                className={styles.input}
                onChange={e => {
                  this.setState({ isCheckedVisa: e.target.checked });
                }}
              />
            </div>
          </form>
        </div>
      </div>
    );
  };

  componentDidMount() {
    const {
      resetPaymentMethod,
      getAllPaymentMethod,
      hideModalPaymentMethod,
      schedulesSelected
    } = this.props;
    this.methods.fetchBLVPContent();
    resetPaymentMethod();
    hideModalPaymentMethod();

    if (size(schedulesSelected) > 1) {
      this.props.getAllPaymentMultiBooking({});
    } else {
      getAllPaymentMethod("", isMobile ? "web" : "pc");
    }
  }

  renderBlvpModal = () => {
    const { isShowBlvpModal, blvpContent } = this.state;
    return (
      <Modal
        iconTitle={<i className="fal fa-bell" />}
        modal={isShowBlvpModal}
        title="Thông báo"
        centered
        footer
        footerConfirm
        className="centered"
        okText="Đóng"
        onOk={this.methods.toggleBlvpModal}
        cancelText=""
      >
        <div className={cx(isMobile && styles.blvp_modal_body)}>
          {typeof blvpContent === "string" && isHTML(blvpContent) ? (
            <div
              dangerouslySetInnerHTML={{
                __html: blvpContent
              }}
            />
          ) : (
            blvpContent
          )}
        </div>
      </Modal>
    );
  };

  componentWillUnmount() {
    this.props.OnResetErrorMessgeSubmitPayment();
  }

  validatePhone = (rule, value, callback) => {
    if (value) {
      const patternMobile = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
      if (patternMobile.test(value)) {
        callback();
      } else {
        const patternPhone = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
        if (patternPhone.test(value)) {
          callback();
        } else callback("Vui lòng nhập đúng định dạng!");
      }
    } else {
      callback("Vui lòng nhập số điện thoại!");
    }
  };

  validatorEmail = (rule, value, callback) => {
    if (typeof value !== typeof undefined && !!value) {
      const trimValue = (value + "").trim();
      if (!isEmpty(trimValue)) {
        if (!isEmail(trimValue)) {
          callback("Vui lòng nhập đúng định dạng email !");
        } else callback();
      } else callback();
    } else callback("Vui lòng nhập email !");
  };

  handleCancel = () => {
    this.setState({ isCheckedVisa: false });
    this.methods.toogleModalVisa();
  };

  render() {
    const {
      errorMsg,
      errorBooking,
      isRedirectToPaymentSupportPage,
      loading
    } = this.props;

    const {
      isShowAlert,
      isShowPaymentConfirm,
      loadingSubmitBooking,
      isCheckedVisa,
      updateVisa
    } = this.state;

    const errorMessage =
      errorBooking.error_code === 1011
        ? `Chuyên khoa ${errorBooking.booking_info.subject.name}
        đã hết số khung giờ này. Vui lòng chọn lại khung giờ khác!`
        : errorBooking.error_code;

    if (isRedirectToPaymentSupportPage)
      return <Redirect to="/ho-tro-thanh-toan" />;

    if (loading) {
      return (
        <div className={styles.loading_spinner}>
          <div className={styles.loading}>
            <MDBSpinner big crazy tag="div" />
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        {this.renderBlvpModal()}
        <PaymentMethodPageDesktop
          {...this.props}
          {...this.methods}
          {...this.state}
        />

        {loadingSubmitBooking && !errorMsg && (
          <div style={this.styles.loading_submit_booking}>
            <div style={this.styles.loading}>
              <MDBSpinner big crazy tag="div" />
            </div>
          </div>
        )}

        <Alert
          isModal={!!errorBooking}
          message={errorMessage || ""}
          toggleAlert={this.methods.toggleAlertFail}
        />
        <Alert
          isModal={isShowAlert}
          message="Vui lòng chọn phương thức thanh toán"
          toggleAlert={this.methods.toggleAlert}
        />

        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={updateVisa.status}
          title="Thông báo"
          centered
          className="centered"
          toggle={this.handleCancel}
          okText="Xác nhận"
          cancelText="Trở lại"
          footer
          footerConfirm
          okDisabled={!isCheckedVisa}
          onCancel={this.handleCancel}
          children={this.renderBodyVisaUmc()}
          onOk={() => this.methods.handleUpdateInfoUser()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { IsAuthenticated },
    payment: { selectedMethod, data, showModal, price },
    doctorAndTime: { sumaryInfo },
    umcSubmitPayment: {
      isRedirectToPaymentSupportPage,
      errorMsg,
      errorBooking
    },
    features: { selectedFeature, selectedFeatureBooking },
    totalData: {
      schedulesSelected,
      bookingTree,
      loadingReserveBooking,
      loading,
      isRepayment,
      partnerId,
      subject: { isHasSubject },
      service: { isHasService },
      room: { isHasRoom },
      doctor: { isHasDoctor },
      treeId,
      addonServices
    },
    hospital: { hospitalSelected },
    patient,
    booking: { addonMedproCare, medproCare }
  } = state;
  return {
    IsAuthenticated,
    device: type,
    platform: type === "desktop" ? "pc" : "web",
    selectedMethod,
    sumaryInfo,
    isRedirectToPaymentSupportPage,
    errorMsg,
    errorBooking,
    showModal,
    data,
    selectedFeature,
    selectedFeatureBooking,
    schedulesSelected,
    bookingTree,
    loadingReserveBooking,
    price,
    loading,
    isRepayment,
    hospitalSelected,
    partnerId,
    isHasSubject,
    isHasService,
    isHasRoom,
    isHasDoctor,
    patient,
    treeId,
    addonServices,
    addonMedproCare,
    medproCare
  };
};

const mapDispatchToProps = {
  getAllPaymentMethod: getAllPaymentMethod,
  OnTogglePaymentMethod: togglePaymentMethod,
  OnSubmitPayment: submitPayment,
  OnResetErrorMessgeSubmitPayment: resetAlertSubmitFail,
  selectedPaymentMethod: selectedPaymentMethod,
  hideModalPaymentMethod,
  resetPaymentMethod,
  reserveBooking,
  repaymentBooking: reserveBookingRePayment,
  getBookingTree,
  getAllPaymentMultiBooking: getAllPaymentMultiBooking,
  reserveMultipleBookings: reserveMultipleBookings
};

const PaymentMethodHelmet = withTitle({
  component: DetectPaymentMethod,
  title: `${hospitalName.value} | Chọn hình thức thanh toán`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  createForm({
    mapPropsToFields: props => {
      const { UserInfoForm } = props;
      return {
        fullName: createFormField(UserInfoForm?.fullName),
        userName: createFormField(UserInfoForm?.userName),
        email: createFormField(UserInfoForm?.email),
        confirm: createFormField(UserInfoForm?.confirm)
      };
    }
  })(PaymentMethodHelmet)
);
